<template>
  <div>
    <div class="search_">
      <div class="back" @click.stop="backHander">
        <van-icon name="arrow-left" />
      </div>
      <div class="selector" id="select" @click.stop="showHander">
        <div class="selector-item">
          <span>{{ select }}</span>
          <img src="@/assets/images/baby/3.jpg" />
        </div>
      </div>

      <form action="javascript:return true">
        <van-search
          :left-icon="require('@/assets/images/icon/search.png')"
          class="vanSearch"
          :class="[isCancelBaby ? 'vanSearch1' : '']"
        
          placeholder="开始搜索，从新妈变星妈"
          shape="round"
          @focus="searchHander"
        />
      </form>
    </div>
    <baby-age
      :monthAgeData="opthionLit"
      @sendSelect="sendSelect"
      ref="babyage"
    ></baby-age>
  </div>
</template>
<script>
import babyAge from "./babyage"; //宝宝月龄组件
export default {
  data() {
    return {
      opthionLit: [],//月龄数组
      flag: true,//展开标志
      
      select: "全部",
      tagAgeId: "",//月龄id
      isCancelBaby: false, // 取消按钮
    };
  },
  components: {
    babyAge,
  },
  props: {
    monthAgeData: {
      type: Array,
      default: [],
    },
  },
  watch: {
    monthAgeData: {
      handler(newVal,oldVal) {
        {
          this.opthionLit = newVal;
        }
      },
      deep: true,
    },
  },
  methods: {
    backHander() {
      this.$router.push({
        path: "/home",
      });
    },
    sendSelect(item) {
      const { info, flag } = item;
      this.select = info.name;
      this.flag = flag;
      this.tagAgeId = info.id;
      this.searchWidth(info.id)
      this.$emit("sendTagAgeId", this.tagAgeId,this.select);
    },
     searchWidth(id){
       let idA=[0,1,2]
       let idB=[3,4,6]
      if (idA.includes(id)) {
        $(".van-search").css("width", "75%");
      } else if (
          idB.includes(id)
      ) {
        $(".van-search").css("width", "70%");
      } else if (id == 5) {
        $(".van-search").css("width", "65%");
      }
    },
    showHander() {
      this.flag = !this.flag;
      this.flag ? this.$refs.babyage.closeUp() : this.$refs.babyage.closeDown();
    },
    searchHander() {
      sessionStorage.setItem("searchVal", "cagechild");
      this.$router.push({
        path: "/search",
        query: {
          searchIndex: "KqParentAudio",
        },
      });
      this.$store.commit("changeIncludes", []);
      sensors.track("ClickSearch", {
        page_name: this.$route.meta.title,
      });
    },
  },
};
</script>
<style lang="less" scoped>
//搜索框
.search_ {
  width: 100%;
  background: @expertFontColor255;
  overflow: hidden;
  padding-bottom: 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  .back {
    float: left;
    font-size: @indexFontSize20;
    padding-top: 19px;
    width: 22px;
    text-align: right;
    padding-left: 5px;
  }
  .selector {
    // line-height: 46px;
    padding-left: 15px;
    padding-top: 22px;
    float: left;
    .selector-item {
      font-size: @indexFontSize14;
      line-height: 14px;
      span {
        width: 40px;
        margin-right: 4px;
      }
      img {
        padding-bottom: 2px;
        width: 7px;
        height: 5px;
      }
    }
  }
  .van-search {
    width: 75%;
    padding: 12px 0 0 12px;
    font-size: @indexFontSize12;
    float: left;
    .van-search__action {
      padding: 0 12px;
      font-size: @indexFontSize14;
    }
    .van-field__control {
      line-height: 24px;
      padding-left: 2px;
    }
  }
  .vanSearch1 {
    width: 90%;
    padding: 12px 0 0 12px;
  }
  @media screen and (max-width: 640px) {
    .vanSearch1 {
      width: 316px;
    }
  }
  span.canBtn {
    height: 58px;
    width: 47px;
    line-height: 58px;
    display: inline-block;
    font-size: @indexFontSize14;
    color: @expertFontColor51;
    // padding: 22px 0 0;
    text-align: center;
  }
}
</style>
